<template>
  <div class="logistics">
    <div
      class="header acea-row row-between row-top"
      v-for="cart in cartInfo"
      :key="cart.id"
    >
      <div class="pictrue"><img :src="cart.productInfo.image" /></div>
      <div class="text acea-row row-between">
        <div class="name line2">
          {{ cart.productInfo.store_name }}
        </div>
        <div class="money">
          <div>￥{{ cart.truePrice }}</div>
          <div>x{{ cart.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="logisticsCon" v-for="(item, i) in orderInfo" :key="i">
      <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1">物流公司：</span>
              {{ item.express.result.expName }}
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span>
              {{ item.express.result.number }}
            </div>
          </div>
        </div>
        <div class="text">
          <div
            class="copy acea-row row-center-wrapper copy-data"
            :data-clipboard-text="item.express.result.number"
          >
            复制单号
          </div>
          <div @click="showAll(i)" class="copy all acea-row row-center-wrapper copy-data">
            查看物流信息
          </div>
        </div>
      </div>
      <div
        class="item"
        v-for="(express, index) in item.express.result.list"
        :key="index"
      >
        <div class="circular" :class="index === 0 ? 'on' : ''"></div>
        <div class="text" v-if="index === 0 || (index!== 0 && item.express.result.isHidden == 1)">
          <div :class="index === 0 ? 'font-color-red' : ''">
            {{ express.status }}
          </div>
          <div class="data">{{ express.time }}</div>
        </div>
      </div>
      <div class="no-express" v-if="loaded && !item.express.result.list.length">
        <img src="@assets/images/noExpress.png" />
      </div>
    </div>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
import { getShipExpress } from "@api/order";

const NAME = "Logistics";

export default {
  name: NAME,
  data: function() {
    return {
      id: null,
      isHidden: {},
      cartInfo: [],
      orderInfo: [{ express: { result: {} } }],
      loaded: false
    };
  },
  created() {
    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
    }
  },
  mounted() {
    this.getExpress();
  },
  methods: {
    showAll(index) {
      this.orderInfo[index].express.result.isHidden = this.orderInfo[index].express.result.isHidden == 1? 0 : 1
    },
    getExpress() {
      if (!this.id) return this.$dialog.error("订单不存在");
      this.loaded = false;
      getShipExpress(this.id)
        .then(res => {

          res.data.map(item => {
            this.isHidden[item.ROW_NUMBER] = true
            return item.express.result.isHidden = 0
          })
          this.orderInfo = res.data;
          console.log(this.isHidden)
          this.loaded = true;
          this.$nextTick(function() {
            var copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", () => {
              this.$dialog.success("复制成功");
            });
          });
        })
        .catch(e => {
          console.log(e);
          this.$dialog.error(e.msg || "加载失败123");
        });
    }
  }
};
</script>

<style scoped>
.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}

.logistics .logisticsCon .company .all {
  width: 1.4rem;
  margin-top: 0.1rem;
}

</style>
